module.exports = __webpack_public_path__ + "img/p1-m.d6c8cfce.jpg";